import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { useInView } from 'react-intersection-observer';
import { useTrackEvent } from 'tracking/useTrackEvent';
import { mediaQueries } from 'components/mediaQueries';
import { Colors } from '@zapier/design-system';

type Props = {
  children: ReactNode;
};

export const SubscribeMini = ({ children }: Props) => {
  const trackEvent = useTrackEvent();
  const [ref, inView] = useInView();

  React.useEffect(() => {
    if (inView) {
      trackEvent('component_scrolled_into_view', {
        component: 'Mini Homepage Subscribe CTA',
      });
    }
  }, [ref, inView]);

  return (
    <Outer ref={ref}>
      <Wrapper>
        <Title>Get productivity tips delivered straight to your inbox</Title>
        {children}
        <Paragraph>
          We’ll email you 1/wk, and never share your information.
        </Paragraph>
      </Wrapper>
    </Outer>
  );
};

const Outer = styled.div`
  display: grid;
  place-items: center;
`;

const Wrapper = styled.div`
  display: grid;
  place-items: center;
  text-align: center;
`;

const Title = styled.p`
  font-weight: 800;
  font-size: 19px;
  line-height: 140%;
  margin-bottom: 20px;
  padding: 0 20px;
  ${mediaQueries.tablet} {
    padding: 0;
    margin-bottom: 30px;
  }
  ${mediaQueries.desktop} {
    margin-bottom: 20px;
  }
`;

const Paragraph = styled.p`
  color: ${Colors.grey700};
  font-size: 11px;
  line-height: 130%;
  margin-top: 30px;
`;
